import React, { Component } from 'react'
import {Link, StaticQuery, graphql} from 'gatsby'
import abstractMenu from './abstractMenu'

//Can't dynamically change staticquery, so just making a basic
//component here for TULSA and then another for other menu items
class AboutusMenu extends Component {

  render(){
    let tulsaOut = <StaticQuery
    query={graphql`
        query {
            allNodeTulsa(sort: {order: ASC, fields: title}) {
                nodes {
                    title
                    fields {
                        slug
                    }
                }
            }
        }
    `}
    render={data => {
        let nodes = data.allNodeTulsa.nodes
        let output = nodes.map((link, i)=>{
            return (
                <li key={i}><Link className="button" to={link.fields.slug}>{link.title}</Link></li>
            )
        })
        return output
    }}/>

    if(!this.props.mobile){
      return (
        <li className="tulsa-menu" onMouseOver={() => {
            this.props.setMenu({menu: true}, ()=> {
                document.addEventListener('click', this.props.hideDropdownMenu)
            })
        }} onMouseOut={() => {
            this.props.setMenu({menu: false})
        }}><Link to="/about">About</Link>
          <ul className={`tulsa-inner-menu ${this.props.menu ? 'show': 'hide'}`} onMouseOut={() => {
              this.props.setMenu({menu: false})
          }}>
              <li><Link className="button" to="/our-team/">Our team</Link></li>
              <li><Link className="button" to="/about/">Overview</Link></li>
          </ul>
        </li>
      )
    }else {
      return (

        <li><a href='#' onClick={e => {
            e.preventDefault()
            this.props.setMenu({menu: true}, ()=> {
                document.addEventListener('click', this.props.hideDropdownMenu)
            })

        }}>About</a>
          <ul className={`${this.props.menu ? 'show': 'hide'}`} >
             <li><Link className="button" to="/our-team/">Our team</Link></li>
             <li><Link className="button" to="/about/">Overview</Link></li>
          </ul>
        </li>
      )
    }
  }
}

export default abstractMenu(AboutusMenu)
